var Register = function() {

	var comp = $('[data-component="register"]');
	var aux;

	this.init = function() {

		mask();

		formValidate();


		if($(window).width() < 768) {
			mobileModal();
		}

	}

	function mobileModal() {
		TweenMax.to(comp, 0.5, {css:{marginTop: '10px'}});
	}

	function mask(){
		comp.find('#cnpj').mask('00.000.000/0000-00', {reverse: true});
		comp.find('#cpf').mask('000.000.000-00', {reverse: true});
		comp.find('#phone').mask('(00) 00000-0000');
	}

	function formValidate(){

		$('#form-register-pj').validate({
			ignore: '.ignore',
			errorPlacement: function() {
			 	return true;
			},
			rules: {
				name: {
					required: true
				},
				email: {
					required: true,
					email: true
				},
				phone: {
					required: true
				},
				cnpj: {
					required: true
				}
			},
			submitHandler: function(form) {

				if ($(form).valid()) {

					$(form).find("button").attr("disabled", true);

					var ComponentID = $(comp).data("id");
					var BankAccountData = {
						"Name": $(comp).find("input[name='name']").val(),
						"CNPJ": $(comp).find("input[name='cnpj']").val(),
						"Email": $(comp).find("input[name='email']").val(),
						"Telephone": $(comp).find("input[name='phone']").val()
					};

					$.ajax({
						type: "POST",
						url: "/umbraco/surface/Account/Send",
						data: JSON.stringify({ "BankAccountData": BankAccountData, "ComponentID": ComponentID }),
						dataType: "json",
						async: true,
						contentType: "application/json; charset=utf-8",
						success: function (response) {

							$("[data-component='contact'] .text").text("Entraremos em contato com você!");
							$('.to-hidden').trigger('click');

							$(form).find("button").attr("disabled", false);
						},
						error: function (e) {

							$("[data-component='contact'] .text").text('Erro ao enviar a mensagem!');
							$('.to-hidden').trigger('click');

							$(form).find("button").attr("disabled", false);
						},

					});
				}
			}
		});

		$('#form-register-pf').validate({
			ignore: '.ignore',
			errorPlacement: function() {
			 	return true;
			},
			rules: {
				name: {
					required: true
				},
				email: {
					required: true,
					email: true
				},
				cpf: {
					required: true
				},
				phone: {
					required: true
				},
				cnpj: {
					required: true
				}
			},
			submitHandler: function(form) {
			}
		});

	}

	/*comp.find('.btn-finalize').on('click', function(e){
		aux = $(this).closest('form').attr('id');
		$('#'+aux).submit();
		if($('#'+aux).find('.error').length < 1) {
			$('.to-hidden').trigger('click');
		}
	})*/

	return this.init();

}